import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../Model/Share/Network/FetchModule.js';
import { useLanguage } from '../../Context/LanguageContext';

import MyStoreSettingTopModel from '../Component/MyStoreSettingTopModel.js';
import MyAccountBox from '../Component/MyAccountBox.js';
import MyStoreIntroductionBox from '../Component/MyStoreInstroductionBox.js';
import ProgramFollowBox from '../Component/ProgramFollowBox.js';
import PartnerGymFollowBox from '../Component/PartnerGymFollowBox.js';
import TermContract from '../Component/TermContract.js';
import TermsEditModal from '../Component/TermsEditModal.js';
import TermsViewModal from '../Component/TermsViewModal.js';
import TermsDeleteModal from '../Component/TermsDeleteModal.js';
import TermsAlertModal from '../Component/TermsAlertModal.js';
import ProvisionEditModal from '../Component/ProvisionEditModal.js';
import ProvisionDeleteModal from '../Component/ProvisionDeleteModal.js';
import ZoneSubscribeBox from '../Component/ZoneSubscribeBox.js';
import LinkoPayBox from '../Component/LinkoPayBox.js';
import LinkoSubmitModal from '../Component/LinkoSubmitModal.js';
import RefundModal from '../../Model/Individual/MySettingModel/RefundModal.js';
import SubscribeModal from '../../Model/Individual/MySettingModel/SubscribeModal.js';
import MemberListExportModal from '../../Model/Individual/MySettingModel/MemberListExportModal.js';
import BillingInfoModal from '../../Model/Individual/MySettingModel/BillingInfoModal.js';
import { toBeRequired } from '@testing-library/jest-dom/dist/matchers.js';

export default function MyStoreSettingPage() {
  const history = useHistory();
  const { t } = useLanguage();

  const [isClickedSubscribe, setIsClickedSubscribe] = useState(false);
  const [isViewBillingInfoModal, setIsViewBillingInfoModal] = useState(false);
  const [isClickedModify, setIsClickedModify] = useState(false);

  const [billingInfo, setBillingInfo] = useState(undefined);

  const [isClickedModifyAccount, setIsClickedModifyAccount] = useState(false);
  const [isClickedModifyGymInfo, setIsClickedModifyGymInfo] = useState(false);
  const [isClickedModifyTerms, setIsClickedModifyTerms] = useState(false);
  const [isClickedRefund, setIsClickedRefund] = useState(false);
  const [isClickedLinkoPay, setIsClickedLinkoPay] = useState(false);
  const [refundData, setRefundData] = useState();

  const [productName, setProductName] = useState('');
  const [productCoach, setProductCoach] = useState('');
  const [productValidity, setProductValidity] = useState(0);
  const [productPrice, setProductPrice] = useState(0);
  const [productMerchantUid, setProductMerchantUid] = useState('');

  const [data, setData] = useState(undefined);
  const [salesList, setSalesList] = useState(new Array);
  const [subscribeList, setSubscribeList] = useState(new Array);
  const [rendering, setRendering] = useState(false);

  const [exerciseFollows, setExerciseFollows] = useState([]);
  const [exerciseFollowers, setExerciseFollowers] = useState([]);

  const [partnerGymFollows, setPartnerGymFollows] = useState([]);
  const [partnerGymFollowers, setPartnerGymFollowers] = useState([]);

  const [linkopay, setLinkopay] = useState(undefined);

  const [businessRegistrationNumber, setBusinessRegistrationNumber] = useState('');
  const [representativeName, setRepresentativeName] = useState('');
  const [linkoEmail, setLinkoEmail] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [settleCycle, setSettleCycle] = useState(5);
  const [settleCycleUnit, setSettleCycleUnit] = useState('day');

  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [storeLogo, setStoreLogo] = useState('');
  const [storeLogoThumbnail, setStoreLogoThumbnail] = useState('');
  const [storeName, setStoreName] = useState('');
  const [tel, setTel] = useState('');
  const [type, setType] = useState('');
  const [address, setAddress] = useState('');
  const [openingHour, setOpeningHour] = useState('');
  const [storeIntro, setStoreIntro] = useState('');
  const [profiles, setProfiles] = useState([]);
  const [profileThumbnails, setProfileThumbnails] = useState([]);
  const [isUsePaymentSystem, setIsUsePaymentSystem] = useState('No');

  const [alertTitle, setAlertTitle] = useState(t('myStoreSetting.terms.deleteProvisionTitle'));
  const [alertText, setAlertText] = useState(t('myStoreSetting.terms.deleteProvisionDefault'));

  const [isClickedExportExcelModal, setIsClickedExportExcelModal] = useState(false);

  const [isClickedViewTerms, setIsClickedViewTerms] = useState(false);
  const [isClickedEditTerms, setIsClickedEditTerms] = useState(false);
  const [isClickedEditProvision, setIsClickedEditProvision] = useState(false);
  const [isClickedDeleteTerms, setIsClickedDeleteTerms] = useState(false);
  const [isClickedDeleteProvision, setIsClickedDeleteProvision] = useState(false);
  const [isViewAlertModal, setIsViewAlerModal] = useState(false);
  const [isClickedLinkopaySubmit, setIsClickedLinkopaySubmit] = useState(false);

  const [isClickedTerms, setIsClickedTerms] = useState(false);

  const [isSavingTerms, setIsSavingTerms] = useState(false);
  const [isSavingProvision, setIsSavingProvision] = useState(false);

  const [clickedTerms, setClickedTerms] = useState(undefined);
  const [clickedProvision, setClickedProvision] = useState(undefined);

  const [terms, setTerms] = useState([]);

  const [defaultProvisions, setDefaultProvisions] = useState([
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision1Title'),
      text: t('myStoreSetting.terms.defaultProvision1Text')
    },
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision2Title'),
      text: t('myStoreSetting.terms.defaultProvision2Text')
    }
  ])

  const [provisions, setProvisions] = useState([]);

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('account/find', 'GET');

        // console.log('account info\n', responseData);
        
        if (responseData.status === 200) setData(responseData.data[0]);
        else if (responseData.status === 401) history.push('/');

        const subscribeResponseData = await fetchModule.getIndividualData('zone_subscribe/list');
        if (subscribeResponseData.status === 200) {

          let subscribeList = subscribeResponseData.data.slice();

          subscribeList.sort(function (a, b) {
            let x = a.approvalDate;
            let y = b.approvalDate;

            if (x < y) return 1;
            if (x > y) return -1;
          })

          let finalSubscribes = [];
          let subscribeCount = 0;

          for (let i = 0; i < subscribeList.length; i++) {
            if ((subscribeList[i].itemName === 'Link-Zone 정기 구독권' 
              || subscribeList[i].itemName === 'Link-Zone 정기 구독권 (1개월)')
              && subscribeCount < 2) {
              finalSubscribes.push(subscribeList[i]);
              subscribeCount += 1;
            }
            else if (subscribeList[i].itemName !== 'Link-Zone 정기 구독권'
              && subscribeList[i].itemName !== 'Link-Zone 정기 구독권 (1개월)'
              && !subscribeList[i].itemName.includes('카카오 알림톡 사용')
            ) finalSubscribes.push(subscribeList[i]);
          }

          setSubscribeList(finalSubscribes);
        }
      }
    )();
  }, [history, rendering])

  // 센터 약관 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('terms/', 'GET');

        if (responseData.status === 200) {
          setTerms(responseData.data.terms);
          setProvisions(responseData.data.provisions);
        }
      }
    )();
  }, [])

  // 운동 프로그램 팔로우 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfExerciseVersion2('share/', 'GET');
        
        if (responseData.status === 200) {
          setExerciseFollows(responseData.data.follows);
          setExerciseFollowers(responseData.data.followers);
        }
      }
    )();
  }, [])

  // 파트너 체육관 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('partner_gym/', 'GET');
        if (responseData.status === 200) {
          setPartnerGymFollows(responseData.data.follows);
          setPartnerGymFollowers(responseData.data.followers);
        }
      }
    )();
  }, [])

  // 링코페이 데이터 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('system/linkopay_permission', 'GET');
        if (responseData.status === 200) {
          if (responseData.data !== undefined) {
            setLinkopay(responseData.data);
            setBusinessRegistrationNumber(responseData.data.businessRegistrationNumber);
            setRepresentativeName(responseData.data.representativeName);
            setLinkoEmail(responseData.data.email);
            setBankName(responseData.data.bankName);
            setAccountNumber(responseData.data.accountNumber);
            setSettleCycle(responseData.data.settlementCycle);
            setSettleCycleUnit(responseData.data.settlementCycleUnit);
          }
        }
      }
    )();
  }, [])

  // Data Setting //
  useEffect(() => {
    if (data === undefined) return;

    setId(data.loginId);
    setEmail(data.email);
    setOwnerName(data.ownerName);
    setPhone(data.phone);
    setPhoneCountryCode(data.countryCode || '');
    setStoreLogo(data.storeLogo);
    setStoreLogoThumbnail(data.storeLogoThumbnail);
    setStoreName(data.storeName);
    setAddress(data.storeAddress);
    setTel(data.storeTel);
    setType(data.storeType);
    setOpeningHour(data.openingHour);
    setStoreIntro(data.introduce);
    setIsUsePaymentSystem(data.isUsePaymentSystem);

    const newData = parseProfilesFromData(data);

    setProfiles(newData);
    setProfileThumbnails(newData);
  }, [data])

  const parseProfilesFromData = (data) => {
    let dates = Array.isArray(data.profiles) ? data.profiles : data.profiles.split(',');
    return dates.filter(date => date !== '');
  };

  const createCenterInfoRequestData = () => ({
    centerName: storeName,
    tel: tel,
    type: type,
    address: address,
    openingHour: openingHour,
    isUsePaymentSystem: isUsePaymentSystem,
    introduce: storeIntro,
    logo: storeLogo,
    logoThumbnail: storeLogoThumbnail,
    profiles: profiles
  });

  const updateCenterInfo = async (requestData) => {
    const fetchModule = new FetchModule();

    const responseData = await fetchModule.postDataVersion2('account/center_info/update', 'POST', requestData);

    if (responseData.status === 200) {
      // TopBar 프로필 사진 업데이트 //
      if (window.refreshStoreLogo) {
        window.refreshStoreLogo();
      }

      setData(responseData.data);
      setIsClickedModifyGymInfo(false);
    }
    else if (responseData.status === 201) {
      alert(t('myStoreSetting.alert.paymentSystemRestricted'));
      setIsUsePaymentSystem('No');
    }
    else if (responseData.status === 401) {
      history.push('/');
    }
  };

  // 구독하기 클릭시 //
  function onClickSubscribeButton() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('zone_subscribe/check', 'GET');
        
        if (responseData.status === 200) setIsClickedSubscribe(true);
        else if (responseData.status === 201) {
          setBillingInfo(responseData.data[0]);
          setIsViewBillingInfoModal(true);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  // 계정정보 수정하기, 저장하기 클릭시 //
  function onClickModifyAccount() {
    if (isClickedModifyAccount) {
      // API Call //

      if (ownerName === '') {
        alert(t('myStoreSetting.alert.ownerNameRequired'));
        return;
      }
      else if (phone === '' || phone.length !== 11) {
        alert(t('myStoreSetting.alert.phoneRequired'));
        return;
      }

      const requestData = {
        ownerName: ownerName,
        phone: phone,
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('account/info/modify', 'POST', requestData);

          if (responseData.status === 200) setData(responseData.data);
          else if (responseData.status === 401) history.push('/');
        }
      )();
      setIsClickedModifyAccount(false);
    }
    else {
      if (autoSave()) setIsClickedModifyAccount(true);
    }
  }

  // 센터 정보 저장하기 클릭시 //
  function onClickGymIntroSave() {
    if (storeName === '') {
      alert(t('myStoreSetting.alert.ownerNameRequired'));
      return;
    }
    else if (tel === '') {
      alert(t('myStoreSetting.alert.phoneRequired'));
      return;
    }
    else if (type === '') {
      alert(t('myStoreSetting.centerInfo.selectCenterType'));
      return;
    }

    const requestData = createCenterInfoRequestData();

    updateCenterInfo(requestData);
  }

  // 데이터 수정중 다른 컴포넌트 수정하기 버튼 클릭시 자동 저장 //
  function autoSave() {
    // 계정 정보 수정중 다른 컴포넌트 수정 클릭시 //
    if (isClickedModifyAccount) {
      if (ownerName === '') {
        alert(t('myStoreSetting.alert.ownerNameRequired'));
        return false;
      }
      else if (phone === '' || phone.length !== 11) {
        alert(t('myStoreSetting.alert.phoneRequired'));
        return false;
      }

      const requestData = {
        ownerName: ownerName,
        phone: phone,
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('account/info/modify', 'POST', requestData);
          
          if (responseData.status === 200) setData(responseData.data);
          else if (responseData.status === 401) history.push('/');
        }
      )();

      setIsClickedModifyAccount(false);

      return true;
    }
    // 센터 정보 수정중 다른 컴포넌트 수정 클릭시 //
    else if (isClickedModifyGymInfo) {
      if (storeName === '') {
        alert(t('myStoreSetting.alert.ownerNameRequired'));
        return false;
      }
      else if (tel === '') {
        alert(t('myStoreSetting.alert.phoneRequired'));
        return false;
      }
      else if (type === '') {
        alert(t('myStoreSetting.centerInfo.selectCenterType'));
        return false;
      }

      const requestData = createCenterInfoRequestData();

      (async () => {
        await updateCenterInfo(requestData);
      })();

      return true;
    }
    else return true;
  }

  // 센터 정보 수정하기 클릭시 //
  function onClickModifyCenterInfo() {
    // if (autoSave()) setIsClickedModifyGymInfo(true);
    if (!isClickedModifyGymInfo) {
      if (autoSave()) setIsClickedModifyGymInfo(true);
    }
    else {
      onClickGymIntroSave();
    }
  }

  // 운동 프로그램 팔로우 신청 클릭시 //
  function onClickExerciseFollowApplicateButton(data, isFollow) {
    // 팔로우 창에서 실행된 경우 //
    if (isFollow) {
      if (data.status === undefined) {
        let requestData = {
          followStoreId: data.storeId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/application', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApplied'));
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followCanceled'));
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
    // 팔로워 창에서 실행된 경우 //
    else {
      if (!data.status) {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/apply', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApproved'));
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          shareId: data.shareId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataOfExerciseVersion2('share/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followDeleted'));
              setExerciseFollows(responseData.data.follows);
              setExerciseFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
  }

  // 파트너 체육관 팔로우 신청 클릭시 //
  function onClickPartnerGymFollowApplicateButton(data, isFollow) {
    // 팔로우 창에서 실행된 경우 //
    if (isFollow) {
      if (data.status === undefined) {
        let requestData = {
          followStoreId: data.storeId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/application', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApplied'));
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          partnerId: data.partnerId
        }
        
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followCanceled'));
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
    // 팔로워 창에서 실행된 경우 //
    else {
      if (!data.status) {
        let requestData = {
          partnerId: data.partnerId
        }
        
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/apply', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followApproved'));
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
      else {
        let requestData = {
          partnerId: data.partnerId
        }
    
        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('partner_gym/delete', 'POST', requestData);
            
            if (responseData.status === 200) {
              alert(t('myStoreSetting.alert.followDeleted'));
              setPartnerGymFollows(responseData.data.follows);
              setPartnerGymFollowers(responseData.data.followers);
            }
          }
        )();
      }
    }
  }

  // 계약서 수정하기 클릭시 //
  function onClickModifyTerms() {
    if (!isClickedModifyTerms) setIsClickedModifyTerms(true);
    else {
      let tempTerms = terms.slice();
      let statuses = [];

      tempTerms.map((data) => {
        statuses.push({id: data.id, status: data.status});
      });

      let statusCount = 0;

      statuses.map((data) => {
        if (data.status) statusCount += 1;
      })

      // 2개 이상 켜져있으면 저장 X //
      if (statusCount > 1) {
        setAlertTitle(t('myStoreSetting.terms.termsActivation'));
        setAlertText(t('myStoreSetting.terms.termsActivationLimit'));
        setIsViewAlerModal(true);
        setIsClickedDeleteProvision(false);
  
        return;
      }

      // setIsSavingProvision(true);

      let requestData = {
        statuses: statuses
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('terms/state', 'POST', requestData);
          if (responseData.status === 200) {
            setIsClickedModifyTerms(false);
            // setIsSavingProvision(true);
          }
          else {
            setAlertTitle(t('myStoreSetting.terms.termsSaveTitle'));
            setAlertText(t('myStoreSetting.terms.termsSaveFailed'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            // setIsSavingProvision(false);
          }
        }
      )();
    }
  }

  // 규정 수정하기 클릭시 //
  function onClickModifyProvision(data) {
    setClickedProvision(data);
    setIsClickedEditProvision(true);
  }

  // 규정 저장하기 클릭시 //
  function onClickSaveProvision(data) {
    if (data.title === '') {
      alert(t('myStoreSetting.terms.provisionTitleRequired'));
      return;
    }
    else if (data.text === '') {
      alert(t('myStoreSetting.terms.provisionContentRequired'));
      return;
    }
    else if (isSavingProvision) {
      alert(t('myStoreSetting.terms.provisionSaving'));
      return;
    } 

    setIsSavingProvision(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('terms/provision/save', 'POST', data);
        if (responseData.status === 200) {
          setIsClickedEditProvision(false);
          setTerms(responseData.data.terms);
          setProvisions(responseData.data.provisions);
          setIsSavingProvision(false);
          setClickedProvision(undefined);
        }
        else {
          alert(t('myStoreSetting.terms.provisionSaveFailed'));
          setIsSavingProvision(false);
        }
      }
    )();
  }
  
  // 규정 닫기 클릭시 //
  function onClickExitProvision() {
    setClickedProvision(undefined);
    setIsClickedEditProvision(false);
  }

  // 규정 삭제 클릭시 //
  function onClickDeleteProvision(data) {
    setClickedProvision(data);
    setIsClickedDeleteProvision(true);
  }
  
  // 규정 삭제 닫기 클릭시 //
  function onClickExitDeleteProvision(data) {
    setClickedProvision(undefined);
    setIsClickedDeleteProvision(false);
  }

  // 삭제하기 클릭시 //
  function onClickExcuteDeleteProvision() {
    if (clickedProvision.isDefault) {
      setAlertTitle(t('myStoreSetting.terms.deleteProvisionTitle'));
      setAlertText(t('myStoreSetting.terms.deleteProvisionDefault'));
      setIsViewAlerModal(true);
      setIsClickedDeleteProvision(false);

      return;
    }
    else if (isSavingProvision) {
      alert(t('myStoreSetting.terms.deleting'));
      return;
    }
    else {
      setIsSavingProvision(true);

      let requestData = {
        id: clickedProvision.id
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('terms/provision/delete', 'POST', requestData);
          
          if (responseData.status === 200) {
            setTerms(responseData.data.terms);
            setProvisions(responseData.data.provisions);
            setIsSavingProvision(false);
            setClickedProvision(undefined);
            setIsClickedDeleteProvision(false);
            setIsSavingProvision(false);
          }
          else if (responseData.status === 201) {
            setAlertTitle(t('myStoreSetting.terms.deleteProvisionTitle'));
            setAlertText(t('myStoreSetting.terms.deleteProvisionAlreadyDeleted'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingProvision(false);
          }
          else if (responseData.status === 203) {
            setAlertTitle(t('myStoreSetting.terms.deleteProvisionTitle'));
            setAlertText(t('myStoreSetting.terms.deleteProvisionDefault'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingProvision(false);
          }
          else {
            setAlertTitle(t('myStoreSetting.terms.deleteProvisionTitle'));
            setAlertText(t('myStoreSetting.terms.deleteProvisionFailed'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingProvision(false);
          }
        }
      )();
    }
  }

  // 약관 보기 클릭시 //
  function onClickViewTerms(data) {
    setClickedTerms(data);
    setIsClickedViewTerms(true);
  }

  // 약관 닫기 클릭시 //
  function onClickExitViewTerms() {
    setClickedTerms(undefined);
    setIsClickedViewTerms(false);
  }

  // 약관 추가하기 클릭시 //
  function onClickEditTerms(data) {
    setClickedTerms(data);
    setIsClickedEditTerms(true);
  }

  // 약관 닫기 클릭시 //
  function onClickExitEditTerms() {
    setClickedTerms(undefined);
    setIsClickedEditTerms(false);
  }

  // 약관 저장하기 클릭시 //
  function onClickSaveTerms(data) {
    if (data.title === '') {
      alert(t('myStoreSetting.terms.termsTitleRequired'));
      return;
    }
    else if (data.provisionKeys.length === 0) {
      alert(t('myStoreSetting.terms.termsProvisionRequired'));
      return;
    }
    else if (isSavingTerms) {
      alert(t('myStoreSetting.terms.termsSaving'));
      return;
    } 

    setIsSavingTerms(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('terms/save', 'POST', data);
        if (responseData.status === 200) {
          setTerms(responseData.data.terms);
          setProvisions(responseData.data.provisions);
          setIsSavingTerms(false);
          setClickedTerms(undefined);
          setIsClickedEditTerms(false);
        }
        else {
          alert(t('myStoreSetting.terms.termsSaveFailedAlert'));
          setIsSavingTerms(false);
        }
      }
    )();
  }
  
  // 약관 삭제하기 클릭시 //
  function onClickDeleteTerms(data) {
    setClickedTerms(data);
    setIsClickedDeleteTerms(true);
  }
  
  // 약관 삭제 닫기 클릭시 //
  function onClickExitDeleteTerms() {
    setClickedTerms(undefined);
    setIsClickedDeleteTerms(false);
  }

  // 약관 삭제하기 클릭시 //
  function onClickExcuteDeleteTerms() {
    if (isSavingTerms) {
      alert(t('myStoreSetting.terms.deleting'));
      return;
    }
    else {
      setIsSavingTerms(true);

      let requestData = {
        id: clickedTerms.id
      }
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('terms/delete', 'POST', requestData);
          if (responseData.status === 200) {
            setTerms(responseData.data.terms);
            setProvisions(responseData.data.provisions);
            setIsSavingTerms(false);
            setClickedTerms(undefined);
            setIsClickedDeleteTerms(false);
            setIsSavingProvision(false);
          }
          else if (responseData.status === 201) {
            setAlertTitle(t('myStoreSetting.terms.deleteTermsTitle'));
            setAlertText(t('myStoreSetting.terms.deleteTermsAlreadyDeleted'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingTerms(false);
          }
          else if (responseData.status === 202) {
            setAlertTitle(t('myStoreSetting.terms.deleteTermsTitle'));
            setAlertText(t('myStoreSetting.terms.deleteTermsUnauthorized'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingTerms(false);
          }
          else {
            setAlertTitle(t('myStoreSetting.terms.deleteTermsTitle'));
            setAlertText(t('myStoreSetting.terms.deleteTermsFailed'));
            setIsViewAlerModal(true);
            setIsClickedDeleteProvision(false);
            setIsSavingTerms(false);
          }
        }
      )();
    }
  }

  // 약관 활성화 버튼 클릭시 //
  function onClickTermsStatus(index) {
    let newTerms = terms.slice();

    newTerms[index].status = !newTerms[index].status;

    setTerms(newTerms);
  }

  function onClickSettleSubmit() {
    if (businessRegistrationNumber === '') {
      alert(t('myStoreSetting.linkoPay.businessNumberRequired'));
      return;
    }
    else if (representativeName === '') {
      alert(t('myStoreSetting.linkoPay.representativeRequired'));
      return;
    }
    else if (email === '') {
      alert(t('myStoreSetting.linkoPay.emailRequired'));
      return;
    }
    else if (bankName === '') {
      alert(t('myStoreSetting.linkoPay.bankRequired'));
      return;
    }
    else if (accountNumber === '') {
      alert(t('myStoreSetting.linkoPay.accountRequired'));
      return;
    }

    setIsClickedLinkopaySubmit(true);
  }

  function onClickLinkoPaySubmit() {
    let requestData = {
      businessRegistrationNumber: businessRegistrationNumber,
      representativeName: representativeName,
      email: email,
      bankName: bankName,
      accountNumber: accountNumber
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('system/submit_linkopay', 'POST', requestData);
        if (responseData.status === 200) {
          setIsClickedLinkopaySubmit(false);
          setLinkopay(responseData.data);
        }
      }
    )();
  }

  return (
    <Container>
      {isClickedSubscribe && <SubscribeModal
        name={productName}
        validity={productValidity}
        price={productPrice}
        merchantUid={productMerchantUid}
        setIsClicked={setIsClickedSubscribe} />}
      { isViewBillingInfoModal && <BillingInfoModal data={billingInfo} onClickExit={() => setIsViewBillingInfoModal(false)}/> }
      { isClickedRefund && <RefundModal refundData={refundData} rendering={() => setRendering(!rendering)} exitClick={() => setIsClickedRefund(false)} /> }
      { isClickedExportExcelModal && <MemberListExportModal onClickExit={() => setIsClickedExportExcelModal(false)} /> }
      {
        isClickedViewTerms && 
        <TermsViewModal 
          storeName={storeName}
          clickedTerms={clickedTerms}
          defaultProvisions={defaultProvisions} 
          provisions={provisions}
          onClickExit={onClickExitViewTerms} />
      }
      { 
        isClickedEditTerms &&
        <TermsEditModal
          storeName={storeName}
          clickedTerms={clickedTerms}
          defaultProvisions={defaultProvisions} 
          provisions={provisions}
          onClickExit={onClickExitEditTerms}
          onClickSave={onClickSaveTerms} /> 
      }
      { 
        isClickedEditProvision && 
        <ProvisionEditModal 
          data={clickedProvision} 
          onClickSave={onClickSaveProvision}
          onClickExit={onClickExitProvision}/> 
      }
      { 
        isClickedDeleteProvision && 
        <ProvisionDeleteModal
          onClickExit={onClickExitDeleteProvision}
          onClickExcuteDeleteProvision={onClickExcuteDeleteProvision}/> 
      }
      {
        isClickedDeleteTerms &&
        <TermsDeleteModal
          onClickExit={onClickExitDeleteTerms}
          onClickExcuteDeleteTerms={onClickExcuteDeleteTerms}/>
      }
      {
        isViewAlertModal && <TermsAlertModal title={alertTitle} text={alertText} onClickExit={() => setIsViewAlerModal(false)}/>
      }
      { isClickedLinkopaySubmit && <LinkoSubmitModal onClickSubmit={onClickLinkoPaySubmit} onClickExit={() => setIsClickedLinkopaySubmit(false)}/> }
      <MyStoreSettingTopModel onClickDownloadMemberList={setIsClickedExportExcelModal} onClickSubscribe={onClickSubscribeButton} />
      <MyAccountBox
        onClickModify={onClickModifyAccount}
        isClicked={isClickedModifyAccount}
        id={id} 
        setData={setData} 
        email={email} 
        owenrName={ownerName} 
        setOwnerName={setOwnerName} 
        phone={phone}
        phoneCountryCode={phoneCountryCode}
        setPhone={setPhone}/>
      <MyStoreIntroductionBox
        isClicked={isClickedModifyGymInfo}
        onClickModifyCenterInfo={onClickModifyCenterInfo}
        
        data={data}
        storeLogo={storeLogo}
        setStoreLogo={setStoreLogo}
        storeLogoThumbnail={storeLogoThumbnail}
        setStoreLogoThumbnail={setStoreLogoThumbnail}
        storeName={storeName}
        setStoreName={setStoreName}
        tel={tel}
        setTel={setTel}
        type={type}
        setType={setType}
        address={address}
        setAddress={setAddress}
        openingHour={openingHour}
        setOpeningHour={setOpeningHour}
        isUsePaymentSystem={isUsePaymentSystem}
        setIsUsePaymentSystem={setIsUsePaymentSystem}
        storeIntro={storeIntro}
        setStoreIntro={setStoreIntro}
        onClickSave={onClickGymIntroSave} 
        
        profiles={profiles} 
        profileThumbnails={profileThumbnails}
        // setProfiles={setProfiles} 
        setData={setData} 
        autoSave={autoSave}/>
        
      <LinkoPayBox 
        data={linkopay}
        businessRegistrationNumber={businessRegistrationNumber}
        setBusinessRegistrationNumber={setBusinessRegistrationNumber}
        representativeName={representativeName}
        setRepresentativeName={setRepresentativeName}
        email={linkoEmail}
        setEmail={setLinkoEmail}
        bankName={bankName}
        setBankName={setBankName}
        accountNumber={accountNumber}
        setAccountNumber={setAccountNumber}
        settleCycle={settleCycle}
        setSettleCycle={setSettleCycle}
        settleCycleUnit={settleCycleUnit}
        setSettleCycleUnit={setSettleCycleUnit}
        onClickSettleSubmit={onClickSettleSubmit}/>
      {/* <CenterSubscriptionTermsEdit terms={terms} setTerms={setTerms}/> */}
      <TermContract 
        isClicked={isClickedModifyTerms}

        storeName={storeName}
        
        terms={terms} 
        onClickModifyTerms={onClickModifyTerms}
        provisions={provisions}
        defaultProvisions={defaultProvisions}
        
        onClickTermsStatus={onClickTermsStatus}

        onClickViewTerms={onClickViewTerms}
        onClickEditTerms={onClickEditTerms}
        onClickDeleteTerms={onClickDeleteTerms}
        
        // onClickMakeProvision={onClickMakeProvision}
        onClickModifyProvision={onClickModifyProvision}
        onClickDeleteProvision={onClickDeleteProvision}/>

      <ProgramFollowBox
        follows={exerciseFollows}
        followers={exerciseFollowers}
        onClickFollow={onClickExerciseFollowApplicateButton}/>

      <PartnerGymFollowBox
        follows={partnerGymFollows}
        followers={partnerGymFollowers} 
        onClickFollow={onClickPartnerGymFollowApplicateButton}/>

      <ZoneSubscribeBox subscribeList={subscribeList}/>

      {/* <CenterFollowView follows={exerciseFollows} onClickFollow={onClickExerciseFollowApplicateButton}/>
      <CenterFollowerView followers={exerciseFollowers} onClickFollow={onClickExerciseFollowApplicateButton}/>
      <PartnerGymFollowView follows={partnerGymFollows} onClickFollow={onClickPartnerGymFollowApplicateButton}/>
      <PartnerGymFollowerView followers={partnerGymFollowers} onClickFollow={onClickPartnerGymFollowApplicateButton}/> */}
      {/* <MyZoneSubscribeInfo subscribeList={subscribeList} /> */}
      {/* <MyZoneMemberPaymentView salesList={salesList} onClickRefundButton={onClickRefundButton} /> */}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  // width: 100%;
  width: calc(100% - 28px);
`;